module.exports = __webpack_public_path__ + "static/media/12 - Mid Tom.f525467a.wav";